import {
  PaymentPolicyType,
  ReservationLocation,
} from '@wix/ambassador-table-reservations-v1-reservation-location/types'
import {useCurrencyFormatter, useExperiments} from '@wix/yoshi-flow-editor'

import {EXPERIMENTS} from './constants'

export const usePaymentDetails = (
  reservationLocation?: ReservationLocation,
  partySize?: number,
) => {
  const formatCurrency = useCurrencyFormatter()

  const {experiments} = useExperiments()
  const isPrepaymentPerPartyEnabled = experiments.enabled(EXPERIMENTS.prepaymentPerParty)

  const currency = reservationLocation?.currency || ''

  const {isPerGuestPayment, options} = getPaymentOptions(
    reservationLocation,
    isPrepaymentPerPartyEnabled,
  )

  const isPaymentRuleActive = !!(
    options?.minPartySize &&
    partySize &&
    partySize >= options?.minPartySize
  )
  const pricePerUnit = Number(options?.price) || 0
  const pricePerUnitWithCurrency = currency
    ? formatCurrency({value: pricePerUnit, currency})
    : String(pricePerUnit)

  const totalPrice = isPerGuestPayment ? pricePerUnit * (partySize || 0) : pricePerUnit
  const totalPriceWithCurrency = currency
    ? formatCurrency({value: totalPrice, currency})
    : totalPrice

  return {
    isPaymentRuleActive,
    isPerGuestPayment,
    pricePerUnit,
    pricePerUnitWithCurrency,
    totalPrice,
    totalPriceWithCurrency,
  }
}

function getPaymentOptions(
  reservationLocation?: ReservationLocation,
  isPrepaymentPerPartyEnabled?: boolean,
) {
  if (!isPrepaymentPerPartyEnabled) {
    const reservationPayment = reservationLocation?.configuration?.reservationPayment

    return {
      isPerGuestPayment: true,
      options: {
        price: reservationPayment?.value,
        minPartySize: reservationPayment?.minPartySize,
      },
    }
  }

  const paymentPolicy = reservationLocation?.configuration?.paymentPolicy

  const isPerGuestPayment = paymentPolicy?.paymentPolicyType === PaymentPolicyType.PER_GUEST
  const options = isPerGuestPayment
    ? paymentPolicy?.perGuestOptions
    : paymentPolicy?.perReservationOptions

  return {
    isPerGuestPayment,
    options,
  }
}
